import {
  sendSponsoredProductClick,
  sendSponsoredProductImpression,
  SponsoredProductGAEventData,
} from 'components/header/components/searchbar/components/sponsored-list/ga-events';
import { useOnScreen } from './use-on-screen';
import { trackingHelper } from 'utils/tracking-helper';

type SponsoredProductEventsOptions = {
  productRef: React.MutableRefObject<HTMLDivElement | null>;
  isInViewport: boolean;
} & SponsoredProductGAEventData;

export const useSponsoredProductEvents = (options: SponsoredProductEventsOptions) => {
  const { productRef, isInViewport, ...gaOptions } = options;
  const { contentId } = options;

  const isOnScreen = useOnScreen(productRef, {
    threshold: 0.5,
  });

  const handleClickEvent = (e: PointerEvent) => {
    if (!contentId || e.button === 2) return;

    trackingHelper.dispatchContentClickedEvent(contentId);
    sendSponsoredProductClick(gaOptions);
  };

  if (isOnScreen && contentId && isInViewport) {
    trackingHelper.dispatchContentViewedEvent(contentId);
    sendSponsoredProductImpression(gaOptions);
  }

  return {
    handleClickEvent,
  };
};
